// extracted by mini-css-extract-plugin
export default {"svg":"styles_svg__3Vm8m","container":"styles_container__JAAh9"};